<template>
  <div>
    <h1 class="above-menu">My Profile</h1>

    <nav>
      <ul>
        <router-link tag="li" to="/profile" exact>Profile</router-link>
        <router-link tag="li" to="/profile/preferences">Preferences</router-link>
      </ul>
    </nav>

  </div>
</template>

<script>
  export default {
    name: 'ProfilePageMenu'
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  nav {
    margin-bottom: 1rem;
    border-bottom: 1px solid #eee;

    li {
      @include tablet-portrait-breakpoint {
        display: inline-block;
        min-width: 150px;
        text-align: center;
      }

      padding: 0.5rem 0;
      cursor: pointer;
      color: #b3b3b3;
    }
    li.router-link-active {
      color: inherit;
      border-bottom: 2px solid $color-pfx-brand;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ProfilePageMenu.vue